/* eslint-disable */
import { Avatar, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import cn from 'classnames';
import React from 'react';
import { compose } from 'recompose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import BannerNotificationPropTypes from './BannerNotification.component.props';
import BannerNotificationsListStyles from './BannerNotification.component.styles';

/**
 * BannerNotification
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const BannerNotification = ({ classes, buttons, content, hidden, bannerClasses, icon }) => (
  <Grid container className={!hidden ? cn(classes.banner, bannerClasses) : cn(classes.banner, classes.bannerHidden)}>
    <Grid item xs={12}>
      <Grid container spacing={2} className={classes.flexWrapNowrap}>
        <Grid item>
          <Avatar className={classes.bannerIcon}>{icon || <NotificationsActiveIcon />}</Avatar>
        </Grid>
        <Grid item className={classes.flexGrow1}>
          {content}
        </Grid>
      </Grid>
      {buttons}
    </Grid>
  </Grid>
);

BannerNotification.propTypes = BannerNotificationPropTypes;

export default compose(withStyles(themeCreateInjectableStyles(BannerNotificationsListStyles), { withTheme: true }))(BannerNotification);
